/**
 * Trip Pass coverage, as it arrives on a trip payload from the backend.
 *
 * `source` explains why a trip is covered, which matters for what the UI says: a
 * trip a travel agent set up is covered for the whole group at no cost, and
 * telling the traveller that is more useful than a generic badge.
 */

export const isTripCovered = (trip) => Boolean(trip?.upgrade_info?.covered);

export const getTripPassSource = (trip) => trip?.upgrade_info?.source || null;

export const getTripPassBadgeLabel = (passInfo, t) => {
  if (!passInfo?.covered) {
    return null;
  }

  switch (passInfo.source) {
    case 'partner':
      return t('trip.passBadge.partner');
    default:
      return null;
  }
};

export const getTripPassTooltip = (passInfo, t) => {
  if (passInfo?.source === 'partner') {
    return t('trip.passBadge.partnerTooltip');
  }
  return t('trip.passBadge.tooltip');
};
